import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ReadingVersion} from "../../../../../core/constants/reading-version";


@Component({
  selector: 'app-imaging-project-flow-dialog',
  templateUrl: './imaging-project-klflow-dialog.component.html',
  styleUrls: ['./imaging-project-klflow-dialog.component.css']
})
export class ImagingProjectKLFlowDialogComponent implements OnInit {

  readingVersion: null;

  constructor(public dialogRef: MatDialogRef<ImagingProjectKLFlowDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.readingVersion = data['readingVersion'];
  }

  readonly readingVersions = ReadingVersion;

  ngOnInit() {
  }

  onClickOk(): void {
    this.dialogRef.close('ok');
  }

}
